<template>
  <v-col cols="12" lg="2" class="sticky-sidebar">
    <template v-if="!$vuetify.breakpoint.lgAndDown">
      <v-list
        class="pt-0 sticky-sidebar__item"
        :style="`${
          $vuetify.breakpoint.width < 1400 ? 'max-width: 163px' : null
        }`"
      >
        <active-hosting-plan-selector
          :items="services"
          :value="activeService"
          :returnObject="true"
          @change="changeService"
          itemText="name"
          itemValue="id"
          class="mb-6"
        />

        <v-subheader class="pl-0 p-4 mt-6 pb-3">{{
          $t("heading.hosting.sidebar.manage.title")
        }}</v-subheader>
        <v-list-item-group
          color="primary"
          class="d-flex flex-row flex-lg-column justify-start"
        >
          <v-list-item
            v-for="(subpage, index) in manageSubpages"
            :key="index"
            :active-class="'elevation-4--before'"
            :ripple="false"
            :to="subpage.to"
          >
            <v-list-item-content>
              <v-list-item-title class="p-2">{{
                subpage.title
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-subheader
          v-if="emailSubpages.length > 0"
          class="pl-0 p-4 mt-6 pb-3"
          >{{ $t("heading.hosting.sidebar.email.title") }}</v-subheader
        >
        <v-list-item-group
          v-if="emailSubpages.length > 0"
          color="primary"
          :active-class="'elevation-4--before'"
          class="d-flex flex-row flex-lg-column justify-start"
        >
          <v-list-item
            v-for="(subpage, index) in emailSubpages"
            :key="index"
            :ripple="false"
            :active-class="'elevation-4--before'"
            :to="subpage.to"
          >
            <v-list-item-content>
              <v-list-item-title class="p-2">
                <span>{{ subpage.title }}</span>
                <div v-if="subpage.showDot" class="select-dot" />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>
    <template v-else>
      <active-hosting-plan-selector
        :items="services"
        :value="activeService"
        :returnObject="true"
        @change="changeService"
        itemText="name"
        itemValue="id"
        class="mt-2"
      />
      <v-tabs
        :class="$vuetify.breakpoint.mobile && 'mt-4'"
        :style="$vuetify.breakpoint.lgAndDown && 'padding: 8px 8px!important;'"
        center-active
        class="pt-0 d-flex flex-row flex-lg-column justify-start"
        style="overflow: hidden"
      >
        <v-tab
          v-for="(subpage, index) of subpages"
          :key="index"
          :active-class="$vuetify.breakpoint.lgAndDown ? '' : 'elevation-2'"
          :ripple="false"
          :to="subpage.to"
          :style="
            $vuetify.breakpoint.lgAndDown ? 'min-width: unset!important;' : ''
          "
        >
          <span class="p-2">{{ subpage.title }}</span>
          <div v-if="subpage.showDot" class="select-dot" />
        </v-tab>
      </v-tabs>
    </template>
  </v-col>
</template>

<script>
import ActiveHostingPlanSelector from "./ActiveHostingPlanSelector.vue";

export default {
  components: {
    ActiveHostingPlanSelector,
  },
  props: {
    services: {
      type: Array,
      default: () => {
        [];
      },
    },
    activeService: {
      type: Object,
    },
  },
  methods: {
    changeService: function (item) {
      this.$emit("update:activeService", item);
    },
  },
  computed: {
    isAppSingleServer() {
      return !!this.$store.state.home.app.single_server?.active;
    },
    subpages() {
      let subpages = [];
      let activeService = this.activeService;
      if (this.isAppSingleServer) {
        subpages.push({
          to: "/hosting/usage",
          title: this.$t("heading.hosting.usage.title"),
        });
      } else {
        subpages.push({
          to: "/hosting/summary",
          title: this.$t("heading.hosting.summary.title"),
        });
      }
      if (
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_domains"
        )
      ) {
        subpages.push({
          to: "/hosting/domains",
          title: this.$t("heading.hosting.domains.title"),
        });
      }
      if (
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_ftp"
        )
      ) {
        subpages.push({
          to: "/hosting/ftp",
          title: this.$t("heading.hosting.ftp.title"),
        });
      }
      if (
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_sftp"
        )
      ) {
        subpages.push({
          to: "/hosting/sftp",
          title: this.$t(`heading.hosting.${this.sftpPageType}.title`),
        });
      }
      if (
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_mysql"
        ) ||
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.phpmyadmin_sso"
        )
      ) {
        subpages.push({
          to: "/hosting/databases",
          title: this.$t("heading.hosting.databases.title"),
        });
      }
      if (
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_cron"
        )
      ) {
        subpages.push({
          to: "/hosting/cron",
          title: this.$t("heading.hosting.cron.title"),
        });
      }
      if (
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_file_manager"
        )
      ) {
        subpages.push({
          to: "/hosting/file-manager",
          title: this.$t("heading.hosting.fileManager.title"),
        });
      }
      if (
        activeService.dns_server_enabled &&
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_dns"
        ) &&
        activeService.plan_settings.dns_management_enabled
      ) {
        subpages.push({
          to: "/hosting/dns",
          title: this.$t("heading.hosting.dns.title"),
        });
      }

      if (
        activeService.email_server_enabled &&
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_email"
        )
      ) {
        subpages.push({
          group: "email",
          to: "/hosting/email-addresses",
          title: this.$t("heading.hosting.emailAddress.title"),
          showDot:
            activeService.showEmailRecordConfiguration &&
            !activeService.isEmailRecordsConfigured,
        });
      }

      if (
        activeService.email_server_enabled &&
        activeService.getUserPrivileges(
          activeService.privileges,
          "hosting.manage_email"
        )
      ) {
        subpages.push({
          group: "email",
          to: "/hosting/email-forwarders",
          title: this.$t("heading.hosting.emailForwarders.title"),
        });
      }
      return subpages;
    },
    manageSubpages() {
      return this.subpages.filter((p) => {
        return !p.group || p.group != "email";
      });
    },
    emailSubpages() {
      return this.subpages.filter((p) => {
        return p.group == "email";
      });
    },
    sftpPageType() {
      if (
        this.activeService.plan_settings.default_ssh_access_enabled ||
        this.activeService.plan_settings.allow_user_enable_ssh_access
      ) {
        return "ssh";
      }
      return "sftp";
    },
  },
};
</script>

<style src="./HostingPagesSidebar.scss" lang="scss" scoped />
